import React from "react";
export default function Testimonials() {
    return (
         <section className="content-section light testimonials-section">
        <div className="container">
            <h2 className="display-5 fw-bold text-center mb-5 testimonials-title">What Our Guests Say</h2>
            <div className="rating-highlight text-center mb-5">
                <div className="rating-stars mb-2">
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star-half-alt"></i>
                </div>
                <h4 className="rating-text mb-0">Rated 4.5 out of 5</h4>
                <p className="rating-subtitle">Based on 200+ guest reviews</p>
            </div>
            <div className="row">
                <div className="col-lg-4 col-md-6 mb-3 stagger-animation">
                    <div className="testimonial-card-compact">
                        <div className="testimonial-header-compact mb-2">
                            <h6 className="mb-1 testimonial-author-compact">Rajesh Kumar</h6>
                            <small className="testimonial-location-compact">Mumbai, India</small>
                        </div>
                        <p className="mb-0 testimonial-text-compact">The combination of historical fort views and natural beauty is simply magical. The rooms are luxurious and the service is impeccable.</p>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 mb-3 stagger-animation">
                    <div className="testimonial-card-compact">
                        <div className="testimonial-header-compact mb-2">
                            <h6 className="mb-1 testimonial-author-compact">Pratik Singh</h6>
                            <small className="testimonial-location-compact">London, UK</small>
                        </div>
                        <p className="mb-0 testimonial-text-compact">The nature trails and fort tours were incredible. This resort perfectly balances luxury with authentic cultural experiences.</p>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 mb-3 stagger-animation">
                    <div className="testimonial-card-compact">
                        <div className="testimonial-header-compact mb-2">
                            <h6 className="mb-1 testimonial-author-compact">Jiya Khan</h6>
                            <small className="testimonial-location-compact">Singapore</small>
                        </div>
                        <p className="mb-0 testimonial-text-compact">The infinity pool with fort views is breathtaking. The food was exceptional and the rooms were spotless.</p>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 mb-3 stagger-animation">
                    <div className="testimonial-card-compact">
                        <div className="testimonial-header-compact mb-2">
                            <h6 className="mb-1 testimonial-author-compact">Priya Sharma</h6>
                            <small className="testimonial-location-compact">Delhi, India</small>
                        </div>
                        <p className="mb-0 testimonial-text-compact">An absolutely stunning location with breathtaking views. The hospitality was outstanding and facilities were top-notch.</p>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 mb-3 stagger-animation">
                    <div className="testimonial-card-compact">
                        <div className="testimonial-header-compact mb-2">
                            <h6 className="mb-1 testimonial-author-compact">Prasad Nale</h6>
                            <small className="testimonial-location-compact">Melbourne, Australia</small>
                        </div>
                        <p className="mb-0 testimonial-text-compact">The mountain views from our room were spectacular. The staff was incredibly helpful and the food was delicious.</p>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 mb-3 stagger-animation">
                    <div className="testimonial-card-compact">
                        <div className="testimonial-header-compact mb-2">
                            <h6 className="mb-1 testimonial-author-compact">Anita Patel</h6>
                            <small className="testimonial-location-compact">Ahmedabad, India</small>
                        </div>
                        <p className="mb-0 testimonial-text-compact">A perfect blend of luxury and nature. The fort tours were fascinating and the sunset views were unforgettable.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    )
}